<template>
    <el-table
            :data="tableData"
            style="width: 100%">
        <el-table-column
                prop="name"
                label="姓名"
                width="180">
        </el-table-column>
        <el-table-column
                prop="gender"
                label="性别"
                width="180">
        </el-table-column>
        <el-table-column
                prop="age"
                label="年龄"
                width="180">
        </el-table-column>
        <el-table-column
                prop="service_status"
                label="服务状态">
        </el-table-column>
        <el-table-column
                prop="target_doctor"
                label="对接医生">
        </el-table-column>
        <el-table-column
                label="操作">
            <template slot-scope="scope">
                <el-button
                        @click="handleClick(scope.row)"
                        size="small"
                        type="text">
                    查看
                </el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    export default {
        data() {
            return {
                tableData: [
                    {
                        name: '刘',
                        gender:'男',
                        age:'30',
                        service_status:'正在服务期',
                        target_doctor:'孙医生'
                    },{
                        name: '程',
                        gender:'男',
                        age:'31',
                        service_status:'正在服务期',
                        target_doctor:'陈医生'
                    },{
                        name: '张',
                        gender:'男',
                        age:'35',
                        service_status:'服务已到期',
                        target_doctor:'陈医生'
                    },{
                        name: '李',
                        gender:'男',
                        age:'30',
                        service_status:'正在服务期',
                        target_doctor:'李医生'
                    },{
                        name: '王',
                        gender:'女',
                        age:'32',
                        service_status:'服务已到期',
                        target_doctor:'李医生'
                    },{
                        name: '赵',
                        gender:'女',
                        age:'28',
                        service_status:'正在服务期',
                        target_doctor:'刘医生'
                    }
                ]
            }
        },
        methods:{
            handleClick(row){
                this.$notify({
                    title: '',
                    message: '暂未开放',
                    type: 'success'
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// RemoteRehabitationServiceManagement.vue?5debd1af